import apiServiceCall from "../services/ApiServiceCall";
import wpCall from "../services/WpServerCall";

export const getServiceDescription = (serviceID) => {
    return apiServiceCall().get(`/services/${serviceID}`).then(({data}) => data);
}

export const getServiceCommentsAndRating = (serviceID,page=1) => {
    return apiServiceCall().get(`/services/extras/${serviceID}/rating?page=${page}`).then(({data}) => data);
}

export const getServiceCommentsFromWp = (serviceID, page = 1) => {
    return wpCall().get(`/wp/v2/comments?post=${serviceID}&page=${page}`).then(({ data }) => data);
}

